import { render, staticRenderFns } from "./ChineesGameEasy.vue?vue&type=template&id=76907976&"
import script from "./ChineesGameEasy.vue?vue&type=script&lang=js&"
export * from "./ChineesGameEasy.vue?vue&type=script&lang=js&"
import style0 from "./ChineesGameEasy.vue?vue&type=style&index=0&id=76907976&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports